import React from 'react';
import PageHeader from '../../components/PageHeader';

const TanzaniaConstitution = () => {
    const breadcrumbItems = [
        { label: 'Home', link: '/' },
        { label: 'Administration', link: null },
        { label: 'Tanzania Constitution', link: '/tanzania-constitution' }
    ];
    return (
        <div className="flex">
            <div className="flex-1 p-4">
                <PageHeader items={breadcrumbItems} pageTitle="Tanzania Constitution" />
                {/* Main content goes here */}
            </div>
        </div>
    );
};

export default TanzaniaConstitution;
